import { render } from "./AuraValidationMessage.vue?vue&type=template&id=7513e16e&ts=true"
import script from "./AuraValidationMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraValidationMessage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/aura/components/AuraValidationMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7513e16e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7513e16e', __exports__)) {
    api.reload('7513e16e', __exports__)
  }
  
  module.hot.accept("./AuraValidationMessage.vue?vue&type=template&id=7513e16e&ts=true", () => {
    api.rerender('7513e16e', render)
  })

}


export default __exports__